import Vue from 'vue';
import moment from 'moment';

Vue.filter('time', (date: Date | string) => {
  if (!date) {
     return '';
  }
  if (typeof date === 'number') {
    const minutes = date;
    date = new Date();
    date.setHours(0, minutes, 0, 0);
  }
  return moment(date).format('HH:mm');
});
